<template>
    <div class="automation-action-settings">
        <div class="field">
            <label>{{ t('automations-form-actions-wait-duration_label') }}</label>
            <small>{{ t('automations-form-actions-wait-duration_help') }}</small>
            <div style="display: flex; gap: 12px; margin-top: 8px;">
                <div style="flex: 1;">
                    <input
                        type="number"
                        class="form-control"
                        v-model="amount"
                        placeholder="1"
                        min="0.1"
                        step="0.1"
                    />
                </div>
                <div style="flex: 1;">
                    <select class="form-control" v-model="unit" @change="changed">
                        <option value="minutes">{{ t('automations-form-actions-wait-minutes') }}</option>
                        <option value="hours">{{ t('automations-form-actions-wait-hours') }}</option>
                        <option value="days">{{ t('automations-form-actions-wait-days') }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
var multipliers = { minutes: 1, hours: 60, days: 1440 };

function decompose(totalMinutes) {
    if (!totalMinutes) return { amount: "", unit: "minutes" };
    if (totalMinutes >= 1440 && totalMinutes % 1440 === 0) return { amount: totalMinutes / 1440, unit: "days" };
    if (totalMinutes >= 60 && totalMinutes % 60 === 0) return { amount: totalMinutes / 60, unit: "hours" };
    return { amount: totalMinutes, unit: "minutes" };
}

export default {
    props: {
        properties: Object,
        conditions: Array,
    },
    data: function () {
        var parsed = decompose(this.properties.timeout);
        return {
            title: this.t("automations-form-actions-wait-title"),
            description: this.t("automations-form-actions-wait-description"),
            amount: parsed.amount,
            unit: parsed.unit,
        };
    },
    computed: {
        totalMinutes: function () {
            var val = parseFloat(this.amount) || 0;
            return Math.round(val * (multipliers[this.unit] || 1));
        },
    },
    mounted: function () {
        this.$emit("mounted", this);
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        changed: function () {
            this.$emit("propertiesUpdated", {
                timeout: this.totalMinutes,
            });
        },
        isValid: function () {
            return this.amount !== "" && !isNaN(this.amount) && parseFloat(this.amount) > 0;
        },
    },
    watch: {
        amount: function () { this.changed(); },
    },
};
</script>
